import { render, staticRenderFns } from "./SimpleModeSetting.vue?vue&type=template&id=7e4e5db6&"
import script from "./SimpleModeSetting.vue?vue&type=script&lang=js&"
export * from "./SimpleModeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports